import Swiper from "swiper"

if (document.querySelector(".pricing__slider")) {
    const swiper = new Swiper(".pricing__slider", {
        autoplay: false,
        slidesPerView: "auto",
        spaceBetween: 20,
        navigation: {
            nextEl: ".pricing__slider__navigation_next",
            prevEl: ".pricing__slider__navigation_prev"
        },
        pagination: {
            el: ".pricing__slider__pagination",
            type: "bullets",
            clickable: true
        },
        loop: false
    })
    swiper.on("snapIndexChange", function () {
        if (swiper.isEnd) {
            document.querySelector(".pricing__slider").classList.remove("blur-end")
            document.querySelector(".pricing__slider").classList.add("blur-start")
        } else {
            document.querySelector(".pricing__slider").classList.add("blur-end")
            document.querySelector(".pricing__slider").classList.remove("blur-start")
        }
    })
}
